import request from '@/utils/request'

export function updateTestCfg(data) {
  return request({
    url: 'api/v1/test/update',
    method: 'post',
    data: data
  })
}

export function getTestList(data) {
  return request({
    url: 'api/v1/test/getList',
    method: 'post',
    data: data
  })
}

export function handleStatus(data) {
  return request({
    url: 'api/v1/test/handle',
    method: 'post',
    data: data
  })
}

